import _ from 'lodash';
import { connect } from 'react-redux';
import { search as searchOpisFtpRecords } from '../modules/opisFtpRecord';
import { search as searchDataRecords, add as addDataRecord } from '../modules/dataRecord';
import { searchNotifierLogs } from '../modules/notifierLogs';

import { bindActionCreators } from 'redux';

// XXX memoize
const mapStateToProps = state => {
	let opisFtpRecords = [];
	if (state.lists.opisFtpRecordIds) {
		opisFtpRecords = _.map(state.lists.opisFtpRecordIds, id => state.maps.opisFtpRecord[id]);
	}

	let dataRecords = [];
	if (state.lists.dataRecordIds) {
		dataRecords = _.map(state.lists.dataRecordIds, id => state.maps.dataRecord[id]);
	}

	let notifierLogs = [];
	if (state.lists.notifierLogIds) {
		notifierLogs = _.map(state.lists.notifierLogIds, id => state.maps.notifierLog[id]);
	}

	return {
		notifierLogs,
		opisFtpRecords,
		dataRecords,
		userMap: state.maps.user,
		authUser: state.auth.authUser,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchOpisFtpRecords,
	searchDataRecords,
	searchNotifierLogs,
	addDataRecord,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
